export class pagination {
  public total_count: number;
  public page_size: number;
  public current_page: number;
  public total_pages: number;
  public previous_page_link: string;
  public next_page_link: string;
}
